// extracted by mini-css-extract-plugin
module.exports = {"signBtn":"authMenu_signBtn__XQh0T","logOut":"authMenu_logOut__9ETAo"};